export default function Header() {
  const header: HTMLElement | null = document.querySelector("header");

  if (header) {
    const searchMenuWrapper: HTMLDivElement | null = header.querySelector(".js-search-menu-wrapper");
    const searchMenuBar: HTMLDivElement | null = header.querySelector(".js-search-menu-bar");
    const searchMenuBarInput: HTMLInputElement | null | undefined = searchMenuBar?.querySelector(".js-search-input");
    const searchMenuBarSubmitBtn: HTMLButtonElement | null | undefined = searchMenuBar?.querySelector(".js-search-submit-btn");
    const searchMenuBtn: HTMLButtonElement | null = header.querySelector(".js-search-menu-btn");
    const searchMenuBtnClosedIcon: HTMLSpanElement | null | undefined = searchMenuBtn?.querySelector(".js-closed-icon");
    const searchMenuBtnOpenIcon: HTMLSpanElement | null | undefined = searchMenuBtn?.querySelector(".js-open-icon");

    const handleOpenSearchMenu = () => {
      if (searchMenuBtn && searchMenuBtnClosedIcon && searchMenuBtnOpenIcon) {
        // update search btn and icons
        searchMenuBtn.classList.add("is-open");
        searchMenuBtnClosedIcon.style.display = "none";
        searchMenuBtnOpenIcon.style.display = "flex";
      }
      if (searchMenuBar && searchMenuBarInput && searchMenuBarSubmitBtn) {
        // update search menu bar
        searchMenuBar.style.width = "610px";
        searchMenuBar.style.opacity = "1";
        searchMenuBar.classList.remove("pointer-events-none");
        // update search bar tab index
        searchMenuBarInput.tabIndex = 0;
        searchMenuBarSubmitBtn.tabIndex = 0;
      }
    };

    const handleCloseSearchMenu = () => {
      if (searchMenuBtn && searchMenuBtnClosedIcon && searchMenuBtnOpenIcon) {
        // update search btn and icons
        searchMenuBtn.classList.remove("is-open");
        searchMenuBtnClosedIcon.style.display = "flex";
        searchMenuBtnOpenIcon.style.display = "none";
      }
      if (searchMenuBar && searchMenuBarInput && searchMenuBarSubmitBtn) {
        // update search menu bar
        searchMenuBar.removeAttribute("style");
        searchMenuBar.classList.add("pointer-events-none");
        // update search bar tab index
        searchMenuBarInput.tabIndex = -1;
        searchMenuBarSubmitBtn.tabIndex = -1;
      }
    };

    const handleClickOutside = (e: any) => {
      if (searchMenuWrapper && searchMenuBtn && !searchMenuWrapper.contains(e.target) && searchMenuBtn.classList.contains("is-open")) {
        handleCloseSearchMenu();
      }
    };

    const toggleSearchMenu = () => {
      if (searchMenuBtn && searchMenuBtn.classList.contains("is-open")) {
        handleCloseSearchMenu();
      } else {
        handleOpenSearchMenu();
      }
    };

    const handleFocusEscape = (e: any) => {
      if (e.code === "Escape") {
        handleCloseSearchMenu();
        searchMenuBtn?.focus();
      }
    };

    const handleIsSticky = () => {
      if (window.scrollY === 0) {
        header.setAttribute("data-isSticky", "false");
      } else {
        header.setAttribute("data-isSticky", "true");
      }
    };

    // init
    handleIsSticky();
    document.addEventListener("scroll", handleIsSticky);

    // add event listeners
    if (searchMenuBtn) {
      searchMenuBtn.addEventListener("click", toggleSearchMenu);
      searchMenuBtn.addEventListener("keydown", handleFocusEscape);
    }
    if (searchMenuBarInput) {
      searchMenuBarInput.addEventListener("keydown", handleFocusEscape);
    }
    if (searchMenuBarSubmitBtn) {
      searchMenuBarSubmitBtn.addEventListener("keydown", handleFocusEscape);
    }
    document.addEventListener("click", handleClickOutside);
  }
}
